import {
  CloseStatisticsContentAction,
  LoadStatisticsContentAction,
  OpenStatisticsContentAction,
  SetStatisticsContentAction,
  SetStatisticsItemsAction,
  StatisticsState,
} from '$store/statistics/interface';
import { createSelector, createSlice } from '@reduxjs/toolkit';
import { RootState } from '$store/rootReducer';

const initialState: StatisticsState = {
  items: {},
  contents: {},
  isItemsLoading: true,
  shownItemData: {
    ton: 0,
    eur: 0,
  },
};

export const { actions, reducer } = createSlice({
  name: 'statistics',
  initialState,
  reducers: {
    loadStatisticsItems(state) {
      state.isItemsLoading = true;
    },
    setStatisticsItems(state, action: SetStatisticsItemsAction) {
      state.items = action.payload;
      state.isItemsLoading = false;
    },
    loadStatisticsContent(state, action: LoadStatisticsContentAction) {
      const { date, currency } = action.payload;

      state.contents[date] = {
        ...state.contents[date],
        isLoading: true,
      };
      state.shownItemData = {
        ...state.shownItemData,
        [currency]: date,
      };
    },
    setStatisticsContent(state, action: SetStatisticsContentAction) {
      const { date, content } = action.payload;

      state.contents[date] = {
        ...state.contents[date],
        earnings: content,
        isLoading: false,
      };
    },
    openStatisticsContent(state, action: OpenStatisticsContentAction) {
      const { date, currency } = action.payload;

      state.shownItemData = {
        ...state.shownItemData,
        [currency]: date,
      };
    },
    closeStatisticsContent(state, action: CloseStatisticsContentAction) {
      state.shownItemData = {
        ...state.shownItemData,
        [action.payload]: null,
      };
    },
  },
});

export { reducer as statisticsReducer, actions as statisticsActions };
export const statisticsSelector = (state: RootState) => state.statistics;

export const statisticsContentSelector = createSelector(
  statisticsSelector,
  (_, contentId: number) => contentId,
  (state, contentId) => {
    return state.contents[contentId];
  },
);
